define('store',['exports', 'redux', 'reducer-training', 'reducer-entity', 'reducer-user', 'middleware-set-training', 'middleware-set-entity', 'middleware-set-user'], function (exports, _redux, _reducerTraining, _reducerEntity, _reducerUser, _middlewareSetTraining, _middlewareSetEntity, _middlewareSetUser) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reducerTraining2 = _interopRequireDefault(_reducerTraining);

  var _reducerEntity2 = _interopRequireDefault(_reducerEntity);

  var _reducerUser2 = _interopRequireDefault(_reducerUser);

  var _middlewareSetTraining2 = _interopRequireDefault(_middlewareSetTraining);

  var _middlewareSetEntity2 = _interopRequireDefault(_middlewareSetEntity);

  var _middlewareSetUser2 = _interopRequireDefault(_middlewareSetUser);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var middleware = (0, _redux.applyMiddleware)(_middlewareSetTraining2.default, _middlewareSetEntity2.default, _middlewareSetUser2.default);

  var reducer = (0, _redux.combineReducers)({ training: _reducerTraining2.default, entity: _reducerEntity2.default, user: _reducerUser2.default });

  var store = (0, _redux.createStore)(reducer, middleware);

  // store.subscribe(() => {
  //     console.error((new Date()).getTime() / 1000 + 's. STORE subscribe');
  //     console.dir(store.getState())
  // });

  exports.default = store;
});
